import api from '@/api'
import * as types from './types'

export default {
  setSearchTerm({
    commit
  }, text) {
    commit(types.SET_SEARCH_TERM, text)
  },
  setPageSize({
    commit
  }, pageSize) {
    commit(types.SET_PAGE_SIZE, pageSize)
  },
  setSortDir({
    commit
  }, sortDir) {
    commit(types.SET_SORT_DIR, sortDir)
  },
  setOrderBy({
    commit
  }, orderBy) {
    commit(types.SET_ORDER_BY, orderBy)
  },
  setStatus({
    commit
  }, status) {
    commit(types.SET_STATUS, status)
  },
  setFilterBy({
    commit
  }, filterBy) {
    commit(types.SET_FILTER_BY, filterBy)
  },
  async downloadRequests({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.downloadRequests(data)
        .then(response => {
          resolve(response)
        })
    })
  },
  async downloadRequestStatistics({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.downloadRequestStatistics(data)
        .then(response => {
          resolve(response)
        })
    })
  },
  async downloadDeviceStatistics({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.downloadDeviceStatistics(data)
        .then(response => {
          resolve(response)
        })
    })
  },
  async downloadActivationCardStatistics({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.downloadActivationCardStatistics(data)
        .then(response => {
          resolve(response)
        })
    })
  },
  async downloadBusinessAccountInfo({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.downloadBusinessAccountInfo(data)
        .then(response => {
          resolve(response)
        })
    })
  },
  async downloadDeviceShipments({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.downloadDeviceShipments(data)
        .then(response => {
          resolve(response)
        })
    })
  },
  async downloadRequestsAdhoc({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.downloadRequestsAdhoc(data)
        .then(response => {
          resolve(response)
        })
    })
  },
  async getDataSchema({ commit }, name) {
    return new Promise((resolve, reject) => {
      api.getDataSchema(name)
        .then(response => {
          commit(types.SET_SCHEMA, response.data)
          resolve(response)
        })
    })
  },
  async getChoices({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.getChoices(data)
        .then(response => {
          resolve(response)
        })
    })
  },
  async getQueryTemplates({ commit }) {
    return new Promise((resolve, reject) => {
      api.getQueryTemplates()
        .then(response => {
          commit(types.SET_QUERY_TEMPLATES, response.data)
          resolve(response)
        })
    })
  },
  async saveQueryTemplate({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.saveQueryTemplate(data)
        .then(response => {
          resolve(response)
        })
    })
  },
  async removeQueryTemplate({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.removeQueryTemplate(data)
        .then(response => {
          resolve(response)
        })
    })
  },
  setCurrentTemplate({ commit }, template) {
    commit(types.SET_CURRENT_TEMPLATE, template)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/actions.js